import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChalkboardTeacher,
  faPlayCircle,
} from "@fortawesome/free-solid-svg-icons";

const TutorialContent = ({ tutorialVideos }) => {
  const videos = Array.isArray(tutorialVideos) ? tutorialVideos : [];
  const [activeId, setActiveId] = useState(videos[0]?.id ?? null);

  const activeVideo = videos.find((v) => v.id === activeId) || videos[0] || null;

  return (
    <div className="tutorial-container">
      <div className="tutorial-header">
        <h2><FontAwesomeIcon icon={faChalkboardTeacher} /> Tutorial Video</h2>
        <p className="tutorial-subtitle">Pelajari melalui video tutorial dari YouTube</p>
      </div>

      <div className="tutorial-layout">
        {videos.length > 0 && (
          <aside className="tutorial-playlist">
            <h3 className="tutorial-playlist-title">Daftar Video ({videos.length})</h3>
            <ul className="tutorial-playlist-list">
              {videos.map((video) => (
                <li key={video.id}>
                  <button
                    type="button"
                    className={`tutorial-playlist-item ${activeVideo?.id === video.id ? "active" : ""}`}
                    onClick={() => setActiveId(video.id)}
                  >
                    <span className="tutorial-playlist-num">{video.id}</span>
                    <span className="tutorial-playlist-text">
                      <span className="tutorial-playlist-name">{video.title}</span>
                      <span className="tutorial-playlist-meta">
                        {video.category} · {video.duration}
                      </span>
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </aside>
        )}

        <div className="tutorial-content">
          {activeVideo ? (
            <div className="video-main">
              <div className="video-player">
                <iframe
                  width="100%"
                  height="520"
                  src={`https://www.youtube.com/embed/${activeVideo.youtubeId}`}
                  title={activeVideo.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="video-info">
                <h3>{activeVideo.title}</h3>
                <div className="video-meta">
                  <span className="video-category">{activeVideo.category}</span>
                  <span className="video-duration">
                    <FontAwesomeIcon icon={faPlayCircle} /> {activeVideo.duration}
                  </span>
                </div>
                <p className="video-description">{activeVideo.description}</p>
              </div>
            </div>
          ) : (
            <div className="video-empty">
              <div className="video-empty-icon">🎬</div>
              <h3>Belum ada video</h3>
              <p>Tambahkan data tutorial untuk menampilkan video di sini.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TutorialContent;
